/** WhatsApp Web–inspired skin (GREEN-API WhatsApp instance). */
import { MessengerWorkspace } from "../MessengerWorkspace";

export function WhatsappShell() {
  return (
    <MessengerWorkspace kind="whatsapp" themeClass="theme-whatsapp" brand="WhatsApp" />
  );
}
